import React from "react";

function Header({ title = "Preflight Application" }) {
  return (
     <header className="aviation-header">
      <div className="aviation-header-inner">
        <img
          className="aviation-header-logo"
          src="/IMG_3232.jpg"
          alt=""
            />
      

      <div className="aviation-header-content">
          <h1 className="aviation-header-title">{title}</h1>
          
          <p className="aviation-header-prompt">
            Calculations and Flight Planning Utilities
            </p>
        </div>

        </div>
    </header>
  );
}

export default Header;